<template>
  <div class="mobile-floating">
    <!-- 전화상담 버튼 -->
    <a href="tel:1800-1088" class="float-btn call-btn">
      <span class="btn-pulse"></span>
      <span class="btn-ring"></span>
      <span class="btn-circle">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="btn-text">전화상담</span>
      </span>
    </a>

    <!-- 방문예약 버튼 -->
    <button class="float-btn reserve-btn" @click="$emit('open-form')">
      <span class="btn-pulse"></span>
      <span class="btn-ring"></span>
      <span class="btn-circle">
        <svg viewBox="0 0 24 24" fill="none">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span class="btn-text">방문예약</span>
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'MobileFloating',
  emits: ['open-form']
}
</script>

<style scoped>
.mobile-floating {
  position: fixed;
  bottom: 140px;
  right: 12px;
  z-index: 990;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;
}

/* 공통 버튼 스타일 */
.float-btn {
  position: relative;
  padding: 0;
  border: none;
  cursor: pointer;
  text-decoration: none;
  background: transparent;
}

.btn-circle {
  position: relative;
  z-index: 2;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  color: #fff;
  transition: all 0.2s ease;
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.4);
}

.btn-circle svg {
  width: 28px;
  height: 28px;
}

.btn-text {
  font-size: 12px;
  font-weight: 900;
  letter-spacing: -0.5px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

/* 펄스 애니메이션 */
.btn-pulse {
  position: absolute;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  right: 0;
  top: 0;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.5;
  }
  70% {
    transform: scale(1.4);
    opacity: 0;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}

/* 링 애니메이션 */
.btn-ring {
  position: absolute;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  right: 0;
  top: 0;
  border: 3px solid;
  animation: ring 2s infinite 0.5s;
  opacity: 0;
}

@keyframes ring {
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1.5);
    opacity: 0;
  }
}

/* 전화상담 버튼 */
.call-btn .btn-circle {
  background: linear-gradient(135deg, #00c853 0%, #00a844 100%);
}

.call-btn .btn-pulse {
  background: #00c853;
}

.call-btn .btn-ring {
  border-color: #00c853;
}

.call-btn:active .btn-circle {
  transform: scale(0.95);
}

/* 방문예약 버튼 */
.reserve-btn .btn-circle {
  background: linear-gradient(135deg, #ff6b35 0%, #e63946 100%);
}

.reserve-btn .btn-pulse {
  background: #e63946;
}

.reserve-btn .btn-ring {
  border-color: #e63946;
}

.reserve-btn:active .btn-circle {
  transform: scale(0.95);
}

/* 작은 화면 대응 */
@media (max-width: 360px) {
  .mobile-floating {
    bottom: 65px;
    right: 10px;
  }

  .btn-circle {
    width: 68px;
    height: 68px;
  }

  .btn-circle svg {
    width: 24px;
    height: 24px;
  }

  .btn-text {
    font-size: 11px;
  }

  .btn-pulse,
  .btn-ring {
    width: 68px;
    height: 68px;
  }
}
</style>
